/**
 * Feito pelo agente netexperts
 * Módulo: AnalyticsObra — utils do painel analítico read-only
 * Data: 2026-06-14
 *
 * Helpers puros (sem fetch, sem estado). Operam sobre números/agregados leves.
 */

export const toNumber = (value = '') => {
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0
    let s = String(value).trim()
    if (!s) return 0
    const hasComma = s.includes(',')
    const hasDot = s.includes('.')
    if (hasComma && hasDot) {
        // 7.780.800,00 (BR) ou 7,780,800.00 (US)
        s = s.lastIndexOf(',') > s.lastIndexOf('.')
            ? s.replace(/\./g, '').replace(',', '.')
            : s.replace(/,/g, '')
    } else if (hasComma) {
        s = s.replace(',', '.')
    } else if (hasDot) {
        const parts = s.split('.')
        // 77808.00 = decimal US; 7.780 = milhar BR
        if (!(parts.length === 2 && parts[1].length <= 2)) {
            s = s.replace(/\./g, '')
        }
    }
    s = s.replace(/[^\d.-]/g, '')
    const parsed = Number(s)
    return Number.isNaN(parsed) ? 0 : parsed
}

export const formatCurrency = (value) =>
    toNumber(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

export const formatNumber = (value) =>
    toNumber(value).toLocaleString('pt-BR')

export const formatPercent = (value) => `${toNumber(value).toLocaleString('pt-BR', { maximumFractionDigits: 1 })}%`

// Normaliza data para YYYY-MM-DD (ISO, datetime ou dd/mm/yyyy)
export const toIsoDate = (value) => {
    if (!value) return ''
    const s = String(value).trim()
    if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10)
    const m = s.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
    return m ? `${m[3]}-${m[2]}-${m[1]}` : s
}

// Formata datas (ISO vindo do banco, Date ou já em dd/mm/yyyy) para dd/mm/yyyy
export const formatDate = (value) => {
    if (value === null || value === undefined || value === '') return '-'
    if (typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value.trim())) return value.trim()
    const d = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(d.getTime())) return String(value)
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
}

// Converte série mensal agregada do backend em itens prontos para os gráficos
export const serieToItems = (serie = [], field = 'total') =>
    serie.map((r) => ({
        label: r.label ?? r.mes_ano,
        value: toNumber(r[field]),
        displayValue: formatCurrency(r[field]),
    }))

// Série acumulada mês a mês (para gráficos de tendência)
export const serieToAcumulado = (serie = [], field = 'total') => {
    let acumulado = 0
    return serie.map((r) => {
        acumulado += toNumber(r[field])
        return {
            label: r.label ?? r.mes_ano,
            value: Number(acumulado.toFixed(2)),
            displayValue: formatCurrency(acumulado),
        }
    })
}

export const ANALYTICS_AREAS = ['estoque', 'vendas', 'recebidos', 'a-receber', 'movimentacao']
